
<div>
    <!-- contact edit -->
    <d-contact-edit
        v-model      = "edit"
        :contact-id  = "contact ? contact.id : null"
        :company-id  = "contact && contact.company ? contact.company.id : null"
        :customer-id = "customerId"
        :mode        = "mode"
        @saved       = "onSaved"
    />
    <!-- contact edit -->

    <c-list-card
        v-if             = "contact"
        :background      = "background"
        :edit            = "editContact"
        :highlight-color = "statusColor"
        @edit            = "edit = true"
        @selected        = "onSelect"
    >
        <template v-slot:buttons>
            <div style="margin-top: 2px" v-if="combineAllowed && isContactAdmin">
                <c-toolbar-button
                    tooltip  = "Kontakte zusammenfassen"
                    color    = "primary"
                    icon     = "mdi-set-all"
                    size     = "22"
                    class    = "mt-n1"
                    @click   = "onCombine"
                />
            </div>
        </template>

        <!-- icons for site assignment -->
        <template v-slot:toolbar>
            <div style="position: relative">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div>
                            <div>
                                <v-icon
                                    :color = "statusColor"
                                    v-if   ="contact.siteAssignmentType && contact.siteAssignmentType.id > 1"
                                    size   = "21"
                                    v-bind = "attrs"
                                    v-on   = "on"
                                    class  = "pt-1"
                                >
                                    {{ icon }}
                                </v-icon>
                            </div>
                        </div>
                    </template>
                    <span>{{ contact.siteAssignmentType.name }}</span>
                </v-tooltip>
            </div>
            <div v-if="contact.customer" class="customer-restriction">
                {{ contact.customer.name }}
            </div>
            <c-toolbar-button
                v-if     = "enableUnassign && (!contact.siteAssignmentType || contact.siteAssignmentType.id === 1)"
                :tooltip = "$t('contact.dissolve.tooltip')"
                color    = "red"
                icon     = "mdi-close"
                size     = "21"
                class    = "mt-n1"
                @click   = "onDissolve"
            />
        </template>
        <!-- icons for site assignment -->

        <!-- title with company and parent contact -->
        <template v-slot:title>
            <div class="w-100 v-flex">
                <div style="font-size: 12px;" :class="statusColor + '--text'">
                    <span v-if="isCustomerOnsite">i.a. </span><span>{{ company }}<span v-if="contact.tags"> - {{ contact.tags }}</span></span>
                </div>
                <v-spacer />
                <div class="type mr-1">
                    <div class="contact-parent">
                        {{ parent }}
                    </div>
                    <a @click.stop="onMember(contact)">
                        <v-icon
                            v-if="contact.member && contact.member.length > 0"
                            color="primary"
                            size  ="22"
                            style = "margin-top: -7px"
                        >
                            mdi-account-supervisor
                        </v-icon>
                    </a>
                </div>
            </div>
        </template>
        <!-- title with company and parent contact -->

        <!-- subtitle with contact name and roles -->
        <template v-slot:subtitle>
            <div class="contact-name">
                <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind = "attrs" v-on   = "on">{{ contact.id }} - {{ contact.firstname }} {{ contact.name }}</span>
                    </template>
                    {{ contact.firstname }} {{ contact.name }}
                </v-tooltip>
            </div>

            <div class="v-flex" style="margin-top: -3px;">
                <div v-for="(role, index) in contact.roles" :key="index" class="mr-1">
                    {{ (index === contact.roles.length-1) ? role.name  : role.name + ' + ' }}
                </div>
            </div>
        </template>
        <!-- subtitle with contact name and roles -->

        <template v-slot:body>
            <v-divider class="mt-2 mb-2" />
            <div style="position:relative;"  v-if="contact">
                <div v-if="isGlobal && background" style="position: absolute; top: 2px; font-size: 12px; width: 195px">
                    <div class="success white--text" style="border-radius: 4px; text-align: center">
                        Gilt für alle Anlagen
                    </div>
                </div>
                <div v-if="isGlobalCustomer && background" style="position: absolute; top: 2px; font-size: 12px; width: 195px;">
                    <div class="success white--text" style="border-radius: 4px; text-align: center; height: 38px">
                        <div>Gilt für alle Anlagen des Kunden</div>
                        <div>{{ contact.customer.name }}</div>
                    </div>
                </div>
                <div class="contact-responsibilities">
                    <r-responsibilities
                        v-if="contact.allresponsibilities"
                        :items = "contact.allresponsibilities"
                        :width = "tagwidth"
                        :background-color = "statusColor"
                        :height = "contact.allresponsibilities.length === 4 ? 40 : 60"
                    />
                    <div v-if="incidenttypes.length > 0" class="v-flex">
                        <c-tag
                            :width            = "tagwidth"
                            :label            = "incidenttypes[0].name"
                            :active           = "true"
                            :background-color = "statusColor"
                            class             = "tag"
                        />
                        <div v-if="incidenttypes.length > 1" style="font-size: 11px; padding-left: 5px; padding-top: 4px;">
                            (+ {{ incidenttypes.length - 1 }} weitere)
                        </div>
                    </div>
                </div>
                <v-row class="no-frame">
                    <v-col class="no-frame col-auto">
                        <r-phone-numbers
                            :color  = "statusColor + '--text'"
                            :numbers="contact.phonenumbers"
                        />
                    </v-col>
                    <v-col class="no-frame col-auto">
                    </v-col>
                </v-row>
            </div>
        </template>

        <template v-slot:footer>
            <div class="v-flex" :class="statusColor + '--text'">
                {{ contact.email}}
            </div>
        </template>

    </c-list-card>
</div>
